import React, { Component, Children } from 'react';
import { Grid, InputBase, List, ListItem, ListItemText } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import CustomTypo from '../../components/CustomTypo';
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';
import { BackOnPrimaryIcon } from '../../components/icons';
import GoogleMapMarker from '../../components/GoogleMapMarker';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
  } from 'react-places-autocomplete';
import GoogleMapComponent from '../../components/GoogleMapComponent';
import ButtonCustom from '../../components/ButtonCustom';
import MapInputComponent from '../../components/MapInputComponent';


const styles = theme => ({
    container:{
        padding: theme.spacing(6,0,0,0),
        height: '100%',
    },
    button_save: {
        marginTop: theme.spacing(4)
    },
    map: {
        marginTop:theme.spacing(6),
        position:'relative',
        width: '100%',
        height: '94%',
    },
    buton_select:{
        position:'absolute',
        bottom: theme.spacing(2)
    },
    search:{
        // width: '80%',
        // height: theme.spacing(10),
        // borderRadius: theme.spacing(10),
        // padding: theme.spacing(2,4,2,4),
        // display: 'flex',
        // alignItems: 'center',
        // backgroundColor: theme.palette.background.secondary,
        position: 'absolute',
        top:theme.spacing(2),
        padding: theme.spacing(0,20,0,8)

    },
    search_list:{
        backgroundColor: theme.palette.background.secondary,
        width: '93%',
        position: 'absolute',
        top:theme.spacing(8),
        left:theme.spacing(2),
        borderBottomLeftRadius: theme.spacing(3),
        borderBottomRightRadius: theme.spacing(3),
    },
    input: {
        //backgroundColor: '#000000',
        marginLeft: theme.spacing(2),
        flex: 1,
        width: '200%',
        [theme.breakpoints.down('lg')]: {
            width: '130%',
        },
        [theme.breakpoints.down('md')]: {
            width: '170%',
        },
        [theme.breakpoints.down('sm')]: {
            width: '120%',
        },
        [theme.breakpoints.down('xs')]: {
            width: '130%',
        },
  },
  button_container:{
    marginRight: theme.spacing(4)
  },
  buttonBack: {
    width: theme.spacing(8),
    height: theme.spacing(8),
    backgroundColor: theme.palette.background.tertiary,
    boxShadow:'none',
    borderRadius: theme.spacing(10),
    borderColor: theme.palette.background.transparent,
    opacity: 1,
    cursor: "pointer",
    textAlign: "center",
    touchAction: "manipulation",
    padding: theme.spacing(1.8,1,0,1),
    '&:hover': {
            opacity: 0.5,
        },
    
    //position: 'absolute',
    //top:theme.spacing(2),
    //right:theme.spacing(2),
},
});
function AddressesMapView(props) {

     const handleChange = (address) => {
        props.onHandleChangeSearch(address)
      };
      const handleSelect = (address) => {
          props.onHandleChangeSearch(address)
        geocodeByAddress(address)
          .then(results => {
                //console.log('handleSelect results=', results)
                props.onSearchPlace(results[0])
            })
          .catch(error => console.error('Error', error));
      };
    const {classes, t, add_info, showLoading, onSelectLocation, onCreateNewAddress, addressText, currentLocation} = props
    // console.log('centerRegion=',currentLocation)
    return (
        <div>
            <DrawerCustom 
                open={props.open} 
                onClose={props.onClose}
                fullScreen
                children={        
                        <Grid item container className={classes.container}>
                            <Grid xs={11} item container justify='flex-start'>
                                <CustomTypo variant='h3' mg_left_xl color='onPrimary'>{t('new_address_title')}</CustomTypo>
                            </Grid>
                            <Grid xs={1} item onClick={()=>props.onClose()} container justify='flex-end'>
                                <Grid className={classes.button_container}>
                                    <Grid className={classes.buttonBack} >
                                        <BackOnPrimaryIcon/>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid xs={12} item container justify='center'>
                                {showLoading?<CustomizedCircularProgress/>:null}
                            </Grid>
                            <Grid xs={12} item className={classes.map} container justify='center'> 
                                <GoogleMapComponent center={currentLocation}
                                    onClick={(e)=>onSelectLocation(e)}
                                    >
                                        <GoogleMapMarker myPlace
                                            lat={add_info.lat}
                                            lng={add_info.lon}
                                        />
                                    </GoogleMapComponent>
                                <Grid xs={10} item className={classes.buton_select} container justify='center'>
                                    <ButtonCustom color='primary' size='lg' fullWidth onClick={()=>onCreateNewAddress()}>{t('select_address')}</ButtonCustom>
                                </Grid>   
                                <Grid xs={12} item className={classes.search} container>
                                    <MapInputComponent
                                        defaultAddress={props.addressText}
                                        onSelectAddress = {props.onSelectAddress}/>
                                    {/* <MapInput classes = {classes} t={t}
                                        handleChange={this.handleChange}
                                        address = {addressText}
                                        handleSelect = {this.handleSelect}/> */}
                            </Grid> 
                            </Grid>
                                
                        </Grid>
                }/>
    </div>
    );
}
function MapInput(props){
    const {classes, t} = props
    return(
        <PlacesAutocomplete
        value={props.address}
        onChange={props.handleChange}
        onSelect={props.handleSelect}>
                             
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div>
            <InputBase
            {...getInputProps({
                placeholder: t('search_for'),
                className: classes.input,
            })}
            />
            {suggestions&&suggestions.length>0&&<List component="nav" aria-label="main mailbox folders" className={classes.search_list}>
                {suggestions.map(suggestion => {
                    // const className = suggestion.active
                    // ? 'suggestion-item--active'
                    // : 'suggestion-item';
                    // // inline style for demonstration purpose
                    // const style = suggestion.active
                    // ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                    // : { backgroundColor: '#ffffff', cursor: 'pointer' };
                    return (
                    // <div
                    //     {...getSuggestionItemProps(suggestion, {
                    //     className,
                    //     style,
                    //     })}
                    // >
                        <ListItem button 
                            {...getSuggestionItemProps(suggestion)}>
                                <ListItemText primary={suggestion.description} />
                        </ListItem>
                    //</div>
                    );
                })}
            </List>}

        </div>
        )} 
    </PlacesAutocomplete>       
    )
}
    
export default withStyles(styles)(withTranslation()(AddressesMapView));